<template>
<div class="columns is-multiline">
    <div class="column is-12 is-clearfix">
        <h4 class="title is-uppercase is-size-5 is-inline">Notizen</h4>
        <button class="is-pulled-right button is-small is-primary" @click="showForm">
            <span v-if="!toggleForm">
                Neue Notiz <i class="has-margin-left-0-5 fa fa-plus" title="Formular öffnen"></i></span>
            <i v-if="toggleForm" class="fa fa-minus" title="Formular schließen"></i>
        </button>
        <div class="is-fullwidth has-border-top has-margin-top-0-5 is-none-mobile"></div>
    </div>
    <div class="column is-12 has-padding-bottom-0 has-padding-top-0">
        <div v-if="toggleForm" class="has-padding-top-1">
            <div class="form columns is-multiline">
                <div class="column is-12 is-9-desktop">
                    <div class="field">
                        <div class="control">
                            <textarea class="textarea" aria-label="Notiz" v-model="text" value="">
                            </textarea>
                        </div>
                    </div>
                </div>
                <div class="column is-12 is-3-desktop">
                    <div class="field">
                        <div class="control">
                            <button :class="(loading) ? 'button is-primary is-loading' : 'button is-primary'" @click="submitForm">
                            Erstellen
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="toggleEditForm" class="has-padding-top-1">
            <div class="form columns is-multiline">
                <div class="column is-12 is-9-desktop">
                    <div class="field">
                        <div class="control">
                            <textarea class="textarea" aria-label="Notiz" v-model="edittext" value="">
                            </textarea>
                        </div>
                    </div>
                </div>
                <div class="column is-12 is-3-desktop">
                    <div class="field">
                        <div class="control">
                            <button :class="(loading) ? 'button is-primary is-loading' : 'button is-primary'"  @click="submitEditedModel(editid)">
                            Änderung speichern
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="column is-12 has-padding-top-0 has-padding-bottom-0">
        <div class="columns is-multiline has-padding-top-0 has-padding-bottom-0 is-none-mobile">
            <div class="column is-3">
                <span class="is-uppercase is-size-7 has-text-weight-bold is-borderless">Datum</span>
            </div>
            <div class="column is-9">
                <span class="is-uppercase is-size-7 has-text-weight-bold is-borderless">Notiz</span>
            </div>
        </div>
    </div>
    <ul class="column is-12 list ">
        <li class="item has-padding-top-0-5 has-padding-bottom-0-5 has-border-top" v-for="annotation in annotations" v-bind="annotations" :key="annotation.id">
            <div class="columns is-multiline" >
                <div class=" column is-3">
                     <span class="is-uppercase is-size-7 has-text-weight-bold is-borderless is-none-desktop is-block-mobile">Datum</span>
                    {{ annotation.created_at }}
                </div>
                <div class="column is-6">
                    <span class="is-uppercase is-size-7 has-text-weight-bold is-borderless is-none-desktop is-block-mobile">Notiz</span>
                    {{ annotation.note }}
                </div>
                <div class="column is-12-mobile is-3 has-text-right-desktop">
                    <span class="is-uppercase is-size-7 has-text-weight-bold is-borderless is-none-desktop is-block-mobile">Aktionen</span>
                    <button :class="(loading) ? 'button is-small is-loading' : 'button is-small'" @click="deleteModel('annotations', annotation.id)"><i class="fa fa-minus"></i></button>
                    <button :class="(loading) ? 'button is-small is-loading' : 'button is-small'" @click="editModel(annotation, annotation.id)"><i class="fa fa-edit"></i></button>
                </div>
            </div>
        </li>
    </ul>
</div>
</template>

<script>
import Vue from 'vue'
import VueEvents from 'vue-events'
Vue.use(VueEvents)

export default {
    components: {},
    beforeMount: function () {
    },
    props: ['annotatableid', 'annotatabletype', 'preAnnotations'],
    data: function() {
        return {
            loading: false,
            toggleForm: false,
            toggleEditForm: false,
            text: '',
            edittext: '',
            editid: null,
            annotations: JSON.parse(this.preAnnotations),
            removeQuestionPart: 'die Notiz'
        }
    },
    methods: {
      submitForm() {
          this.loading = true;
          axios.post(`/annotations/${this.annotatabletype}/${this.annotatableid}/new`, {
              text: this.$data.text
          }).then(res => {
              this.loading = false;
              this.annotations.unshift(res.data)
              this.toggleForm = false;
              this.$data.text = '';
            })
        },
        showForm() {
            this.$data.toggleEditForm = false;
            this.$data.toggleForm = !this.$data.toggleForm;
        },
        editModel (model, modelid) {
            this.$data.toggleForm = false;
            this.$data.editid = modelid;
            this.$data.edittext = model.note
            this.toggleEditForm = true
        },
        submitEditedModel(modelid) {
            this.loading = true;
            axios.put(`/annotations/${modelid}`, {
                text: this.$data.edittext
            }).then(res => {
                console.log(res.data)
                this.$data.loading = false;
                this.$data.edittext = '';
                this.$data.editid = '';

                this.$data.annotations.forEach((element, index) => {
                    if(element.id === res.data.id) {
                        this.$data.annotations[index] = res.data;
                    }
                });

                this.$data.toggleEditForm = false;

            }).catch(err => {
                this.$data.loading = false;
                console.log(err);
            })
        },
        deleteModel (model, modelid) {

          if(confirm(`Sicher, dass Sie ${this.removeQuestionPart} entfernen möchten?`)) {
            this.$data.loading = true;
            axios.delete(`/${model}/${modelid}`).then(res => {
              this.$data.loading = false;
              this.annotations = this.annotations.filter(annotation => {
                  return annotation.id !== modelid;
              })
            }).catch(err => {
                console.log(err)
                this.$data.loading = false;
            })
          }
        }
  }

}
</script>

<style>
    .is-width-60 {
        width: 60%;
    }

    .has-border-top {
        border-top: thin #dbdbdb solid;
    }

    @media screen and (max-width: 768px) {
        .is-width-60 {
            width: initial;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ckAnnotation.vue